<template>
    <div class="">
        <info-modal
            ref="infoModal"
            :msg="infoMsg"
        />
        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <div class="bg-liff">
            <div class="header-text">
                <div>
                    {{$vuetify.lang.t('$vuetify.groupAttendaceDetail.attendaceEmployee')}}
                </div>
                <span class="lang mr-3">
                    <change-lang />
                </span>
            </div>
            <div
                class="data-container"
                >
                <v-row>
                    <v-tabs
                    centered>
                        <v-tab
                        append
                        v-for="tabHeader of tabsHeader"
                        :key="tabHeader.value"
                        @click="changeStatus(tabHeader.value)"
                        >
                        {{tabHeader.text}}
                        </v-tab>
                    </v-tabs>
                </v-row>
                <div>
                    <br>
                </div>
                <div>
                    <v-card center-active>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [10, 20, 30, 50, 100]
                            }"
                            @page-count="pageCount = $event"
                            :page.sync="page"
                            :headers="headers"
                            :options.sync="options"
                            :server-items-length="totalData"
                            :items="laos"
                            :loading="loading">
                        </v-data-table>
                    </v-card>
                    <div
                        class="pt-2 paginator-box">
                        <div>
                            <v-pagination v-model="page" :length="pageCount"></v-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InfoModal from '@/components/modal/InfoModal'
import ChangeLang from '@/components/liff/ChangeLang'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import axios from 'axios'
export default {
    name: 'ApprovalInquiry',
    components: {
        InfoModal,
        ChangeLang,
        LiffErrorModal
    },

    data () {
        return {
            infoMsg: null,
            status: null,
            inquireDate: this.$util.getCurrentDate(),
            laos: [],
            pageCount: 1,
            page: 1,
            totalData: 0,
            options: {},
            loading: false,
            errorMsg: '',
            groupId: null,
            timeType: null, // time type is value from line, to say it is Check-in/out ( CO/CI ).
            path: null,
            departmentId: null
        }
    },

    computed: {
        headers () {
            let timeText = null

            // if time type be check out, change header table.
            if (this.timeType === 'CO') {
                timeText = this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.timeCo')
            } else {
                // if time type be check in, change header table.
                timeText = this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.timeCi')
            }
            // if status be ONSITE or LEAVE, change header status.
            if (this.status === 'ONSITE' || this.status === 'LEAVE' || this.timeType === 'CO') {
                return [
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.employeeNo'), value: 'employee__employee_no', width: '10%' },
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.fullName'), value: 'employee__fullname', width: '10%' },
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.status'), value: 'leave_type', width: '10%' },
                    { text: timeText, value: 'time', width: '10%', sortable: false }
                ]
            } else {
                // if status has not ONSITE or LEAVE, change header status.
                return [
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.employeeNo'), value: 'employee__employee_no', width: '10%' },
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.fullName'), value: 'employee__fullname', width: '10%' },
                    { text: timeText, value: 'time', width: '10%', sortable: false }
                ]
            }
        },
        tabsHeader () {
            // if time type be check out, the tab has only 2.
            if (this.timeType === 'CO') {
                return [
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.checkOut'), value: 'NORMAL' }, // NORMAL is hard code send to back-end, for get check-out normal.
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.earlyCheckOut'), value: 'EARLY_OUT' } // EARLY_OUT is hard code send to back-end, for get early check-out.
                ]
            } else {
                // if time type be check out, the tab has 4.
                return [
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.absent'), value: 'ABS' },
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.late'), value: 'LAT' },
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.onsite'), value: 'ONSITE' }, // ONSITE is hard code send to back-end, for get onsite full and half day.
                    { text: this.$vuetify.lang.t('$vuetify.groupAttendaceDetail.leave'), value: 'LEAVE' } // LEAVE is hard code send to back-end, for get leave full and half day.
                ]
            }
        }
    },

    methods: {
        async changeStatus (statusChange) {
            this.status = statusChange
            await this.getInquiryPagination()
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        errorModal (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        async getInquiryPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            if (this.timeType === 'CO') { // if time type = check out, change path to query
                this.path = '/line-attendances/attendance-check-out'
            } else {
                // if time type = check in, change path to query
                this.path = '/line-attendances/attendance-check-in'
            }

            let url = `${process.env.VUE_APP_BACKEND}${this.path}?group=${this.groupId}&inquiryDay=${this.inquireDate}&page=${page}&itemsPerPage=${itemsPerPage}&departmentId=${this.departmentId}`

            if (page) {
                url += `&page=${page}`
            }
            if (itemsPerPage) {
                url += `&itemsPerPage=${itemsPerPage}`
            }
            if (sortBy && sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc && sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.status) {
                url += `&laoType=${this.status}`
            }

            if (this.inquireDate) {
                url += `&inquireDate=${this.inquireDate}`
            }
            const res = await axios.get(url, {
                headers: {
                    'Accept-Language': this.$vuetify.lang.current
                }
            })
            if (res && res.data && res.data.status === 'ok') {
                this.laos = res.data.data
                this.totalData = res.data.total
            } else {
                this.errorModal(res.data.msg)
            }
            this.loading = false
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
        const params = new URLSearchParams(queryString) // get params value from line liff.
        this.groupId = params.get('groupId')
        this.timeType = params.get('type')
        this.departmentId = params.get('departmentId')

        // set default for check in attendance check in
        if (this.timeType === 'CI') {
            this.status = 'ABS'
        } else {
            this.status = 'NORMAL' // set default for check in attendance check out
        }

        await this.getInquiryPagination()
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        options: {
            async handler () {
                if (this.groupId) {
                    await this.getInquiryPagination()
                }
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                // query when time type be check in, becose must show status from back-end
                if (this.timeType === 'CI') {
                    await this.getInquiryPagination()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.bg-liff {
    height: 100vh;
    background-color: #2E2929;
    color: #ffffff;

    .header-text {
        font-family: LexendDeca;
        font-size: 20px;
        padding: 1rem;
        height: 10%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .data-container {
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
        color: #6c6c6c;
        padding: 2rem;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 90%;
    }
}

@media screen and (orientation: landscape) {
    .bg-liff {
        display: flex;
        flex-direction: column;
        align-items: center;

        .data-container {
            min-width: 350px;
        }
    }
}

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

.text-underline {
    text-decoration: underline;
    color: #d76436;
}

.choices-container {
    display: inline-flex;
    padding: 0px 16px;
    font-size: 16px;
    .disable {
        pointer-events: none;
        cursor: not-allowed;
    }

    .choice {
        height: 50px;
        min-width: 84px;
        width: 31%;
        border-top: solid 1px #6c98ba;
        border-bottom: solid 1px #6c98ba;
        color: #6c98ba;

        &:hover {
            background-color: lighten($color: #6c98ba, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #6c98ba;
            cursor: default;
            pointer-events: none;
        }
    }

    .choice:first-child {
        color: #ff544a;
        border: solid 1px #ff544a;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;

        &:hover {
            background-color: lighten($color: #ff544a, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #ff544a;
        }
    }

    .choice:last-child {
        color: #d76436;
        border: solid 1px #d76436;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;

        &:hover {
            background-color: lighten($color: #d76436, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #d76436;
        }
    }

}
.no-data {
    margin-top: 10rem;
    font-size: 22px;
    font-weight: 500;
    color: #6c6c6c;
    text-align: center;
}
::v-deep .v-data-footer__icons-before {
    display: none;
}
::v-deep .v-data-footer__icons-after {
    display: none;
}

::v-deep .v-slide-group {
    display: -webkit-box;
    display: -ms-flexbox;
}
::v-deep .v-tab {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    font-size: 0.875rem;
    font-weight: 500;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal;
    min-width: 28px;
    max-width: 364px;
    outline: none;
    padding: 0px 15px;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    -webkit-transition: none;
    transition: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>
